<template>
  <div class="game-board-page">

    <el-container class="contain-6">

      <div class="bbb game-board-card">
        <el-tabs v-model="activeTab" class="board-tabs" @tab-click="handleTabChange">
          <el-tab-pane label="游戏汇总" name="gameSummary"></el-tab-pane>
          <el-tab-pane label="项目天明细" name="projectDaily"></el-tab-pane>
        </el-tabs>
        <div v-show="echartShow">
          <div ref="chart" style="width: 900px; height: 250px;"></div>


        </div>

        <el-header class="board-toolbar">

          <span class="style-title">游戏名称</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     class="game-select"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>


<!--          <span class="style-title">投手:</span>-->
<!--          <el-input v-model="person" placeholder="请输入投手" size="mini" clearable-->
<!--                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">-->

<!--          </el-input>-->

          <span class="style-title">日期</span>
          <el-date-picker
              v-model="value1"
              type="date"
              class="date-picker"
              value-format="yyyy-MM-dd"
              size="mini" clearable
              placeholder="选择日期">
          </el-date-picker>
          <template v-if="activeTab === 'projectDaily'">
            <span class="style-title">深度出价类型</span>
            <el-select
                v-model="deepBidType"
                placeholder="全部类型"
                size="mini"
                clearable
                class="deep-bid-filter"
                @change="handleDeepBidTypeChange">
              <el-option
                  v-for="item in deepBidTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </template>
          <el-button size="mini"
                     class="refresh-button"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>
          <div class="toolbar-spacer"></div>
          <template v-if="activeTab === 'gameSummary'">
            <span class="meta-pill">共 {{ size }} 个游戏</span>
            <span class="meta-pill">当前页 {{ tableData.length }} 条</span>
          </template>
          <template v-else>
            <span class="meta-pill">共 {{ projectTotal }} 个项目</span>
            <span class="meta-pill">总消耗 {{ formatAmount(projectSummary.total_cost) }}</span>
            <span class="meta-pill">加权ROI {{ formatRoi(projectSummary.weighted_roi) }}</span>
            <span class="meta-pill">快照匹配 {{ formatInteger(projectSummary.snapshot_matched_count) }}</span>
          </template>
          <span class="meta-pill" v-if="value1">{{ value1 }}</span>
<!--          <div style="margin-left: 6px;height: 30px;margin-top:10px;color: black">-->
<!--            <el-switch-->
<!--                v-model="echartShow"-->
<!--                :width="35"-->
<!--            >-->
<!--            </el-switch>-->
<!--          </div>-->

        </el-header>
        <el-table
            v-if="activeTab === 'gameSummary'"
            v-loading="loading"
            ref="tableData1"
            :data="displayTableData"
            stripe
            border
            :fit="false"
            :height="tableHeight"
            class="game-board-table"
            @cell-dblclick="rowClickEvent"
            @cell-click="contextClick"
            :header-cell-style="headerCellStyle"
            :cell-class-name="cellClassName"
            :row-class-name="gameRowClassName"
            size="mini"
            highlight-current-row

            row-key="id"
            lazy
            @sort-change="sortMethod"

        >


          <el-table-column
              prop="gameName"
              label="游戏名"
              width="190"
              fixed="left"
              show-tooltip-when-overflow
          >
            <template slot-scope="{row}">

              <span class="promotion">{{ row.gameName }}</span>
            </template>

          </el-table-column>


          <el-table-column
              prop="statCost"
              label="实时消耗"
              width="125"
              fixed="left"
              align="right"
              header-align="right"
              class-name="cost-cell main-cost-cell"
              sortable
          >
            <template slot-scope="{row}">
              {{ formatAmount(row.statCost) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="sumRoi"
              label="实时ROI"
              width="115"
              fixed="left"
              align="right"
              header-align="right"
              class-name="roi-cell"
              sortable
          >
            <template slot-scope="{row}">
              {{ formatRoi(row.sumRoi) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="f1HAmount"
              label="时速"
              width="105"
              fixed="left"
              align="right"
              header-align="right"
              class-name="speed-cell"
              sortable
          >
            <template slot-scope="{row}">
              {{ formatSpeed(row.f1HAmount) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="oldCost"
              label="旧版消耗"
              min-width="125"
              align="right"
              header-align="right"
              class-name="cost-cell"
              sortable

          >
            <template slot-scope="{row}">

              {{ formatAmount(row.oldCost) }}

            </template>

          </el-table-column>

          <el-table-column
              prop="oldSumRoi"
              label="旧版实时ROI"
              min-width="125"
              align="right"
              header-align="right"
              class-name="roi-cell"
              sortable
          >
            <template slot-scope="{row}">
              {{ formatRoi(row.oldSumRoi) }}
            </template>
          </el-table-column>

          <el-table-column
              v-for="column in oldRateColumns"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              min-width="130"
              align="right"
              header-align="right"
              :class-name="column.formatter === 'roi' ? 'roi-cell split-roi-cell' : 'cost-cell split-cost-cell'"
              sortable
          >
            <template slot-scope="{row}">
              {{ formatDynamicColumn(row, column) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="stdCost"
              label="智擎消耗"
              min-width="125"
              align="right"
              header-align="right"
              class-name="cost-cell"
              sortable

          >
            <template slot-scope="{row}">

              {{ formatAmount(row.stdCost) }}

            </template>

          </el-table-column>

          <el-table-column
              prop="stdSumRoi"
              label="智擎实时ROI"
              min-width="125"
              align="right"
              header-align="right"
              class-name="roi-cell"
              sortable
          >
            <template slot-scope="{row}">
              {{ formatRoi(row.stdSumRoi) }}
            </template>
          </el-table-column>

          <el-table-column
              v-for="column in stdRateColumns"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              min-width="130"
              align="right"
              header-align="right"
              :class-name="column.formatter === 'roi' ? 'roi-cell split-roi-cell' : 'cost-cell split-cost-cell'"
              sortable
          >
            <template slot-scope="{row}">
              {{ formatDynamicColumn(row, column) }}
            </template>
          </el-table-column>


        </el-table>

        <el-table
            v-else
            v-loading="projectLoading"
            ref="projectDailyTable"
            :data="projectRows"
            stripe
            border
            :fit="false"
            :height="tableHeight"
            class="game-board-table project-daily-table"
            :header-cell-style="headerCellStyle"
            size="mini"
            highlight-current-row
            row-key="id"
            @sort-change="sortProjectDaily"
        >
          <el-table-column prop="game_name" label="游戏名称" width="155" fixed="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="stat_date" label="数据日期" width="105" sortable="custom"></el-table-column>
          <el-table-column prop="platform_version" label="投放版本" width="90">
            <template slot-scope="{row}">{{ formatPlatformVersion(row.platform_version) }}</template>
          </el-table-column>
          <el-table-column prop="account_name" label="账号名称" width="190" show-overflow-tooltip></el-table-column>
          <el-table-column prop="account_id" label="账号ID" width="155" show-overflow-tooltip></el-table-column>
          <el-table-column prop="organization_names" label="归属组织" width="210" show-overflow-tooltip></el-table-column>
          <el-table-column prop="project_name" label="项目名称" width="230" show-overflow-tooltip></el-table-column>
          <el-table-column prop="project_id" label="项目ID" width="165" show-overflow-tooltip></el-table-column>
          <el-table-column prop="deep_bid_type" label="深度出价类型" width="135" sortable="custom">
            <template slot-scope="{row}">{{ formatDeepBidType(row.deep_bid_type) }}</template>
          </el-table-column>
          <el-table-column prop="roi_goal" label="ROI目标" width="100" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatRoi(row.roi_goal) }}</template>
          </el-table-column>
          <el-table-column prop="stat_cost" label="消耗" width="115" align="right" header-align="right" sortable="custom" class-name="cost-cell">
            <template slot-scope="{row}">{{ formatAmount(row.stat_cost) }}</template>
          </el-table-column>
          <el-table-column prop="roi" label="实时ROI" width="105" align="right" header-align="right" sortable="custom" class-name="roi-cell">
            <template slot-scope="{row}">{{ formatRoi(row.roi) }}</template>
          </el-table-column>
          <el-table-column prop="show_cnt" label="展示数" width="110" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatInteger(row.show_cnt) }}</template>
          </el-table-column>
          <el-table-column prop="click_cnt" label="点击数" width="105" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatInteger(row.click_cnt) }}</template>
          </el-table-column>
          <el-table-column prop="ctr" label="点击率" width="95" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatPercent(row.ctr) }}</template>
          </el-table-column>
          <el-table-column prop="convert_cnt" label="转化数" width="105" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatInteger(row.convert_cnt) }}</template>
          </el-table-column>
          <el-table-column prop="conversion_cost" label="转化成本" width="110" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatAmount(row.conversion_cost) }}</template>
          </el-table-column>
          <el-table-column prop="conversion_rate" label="转化率" width="95" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatPercent(row.conversion_rate) }}</template>
          </el-table-column>
          <el-table-column prop="micro_game_24h_amount" label="24小时回收" width="120" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatAmount(row.micro_game_24h_amount) }}</template>
          </el-table-column>
          <el-table-column prop="micro_game_0d_roi" label="首日ROI" width="100" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatRoi(row.micro_game_0d_roi) }}</template>
          </el-table-column>
          <el-table-column prop="micro_game_24h_roi" label="24小时ROI" width="110" align="right" header-align="right" sortable="custom">
            <template slot-scope="{row}">{{ formatRoi(row.micro_game_24h_roi) }}</template>
          </el-table-column>
          <el-table-column
              v-for="column in projectRoiColumns"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              width="95"
              align="right"
              header-align="right"
              sortable="custom"
          >
            <template slot-scope="{row}">{{ formatRoi(row[column.prop]) }}</template>
          </el-table-column>
          <el-table-column prop="snapshot_collected_at" label="快照采集时间" width="155" sortable="custom">
            <template slot-scope="{row}">{{ formatDateTime(row.snapshot_collected_at) }}</template>
          </el-table-column>
          <el-table-column prop="collected_at" label="报表采集时间" width="155" sortable="custom">
            <template slot-scope="{row}">{{ formatDateTime(row.collected_at) }}</template>
          </el-table-column>
        </el-table>

        <div v-if="activeTab === 'gameSummary'" class="block pagination-bar">

          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[25,50,100,200]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="size">
          </el-pagination>
        </div>
        <div v-else class="block pagination-bar">
          <el-pagination
              @size-change="handleProjectSizeChange"
              @current-change="handleProjectCurrentChange"
              :current-page.sync="projectCurrentPage"
              :page-sizes="[25,50,100,200]"
              :page-size="projectPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="projectTotal">
          </el-pagination>
        </div>
      </div>

      <el-dialog :visible.sync="dialogTableVisible" width="78%"
                 :title="title"
      >
        <el-table :data="gridData"
                  max-height="75vh"
                  height="74vh"
                  size="mini"
                  stripe
        >
          <el-table-column property="dateHour" label="时间点" sortable width="200" align="center">


          </el-table-column>
          <el-table-column property="hourDelay" label="经过小时" sortable width="110" align="center"></el-table-column>
          <el-table-column property="sevenBl" label="7日(游戏维度)倍率" width="180" align="center"></el-table-column>
          <el-table-column property="nowBl" label="该时间段倍率" width="180" align="center"></el-table-column>
          <el-table-column property="upBl" label="提升比例" width="180" align="center">

            <template slot-scope="{row}">
              <span style="color: #d65055"
                    v-if="row.upBl/row.incomeRatio>0"> {{ row.upBl / row.incomeRatio|dataFilters2 }}</span>

              <span style="color: #5daf34" v-else>{{ row.upBl / row.incomeRatio|dataFilters2 }}</span>
            </template>

          </el-table-column>
          <el-table-column property="sevenRoi" label="7日(游戏维度)ROI" width="180" align="center"></el-table-column>
          <el-table-column property="nowRoi" label="该时间ROI" width="150" align="center"></el-table-column>
          <el-table-column property="upRoi" label="提升比例" width="150" align="center">
            <template slot-scope="{row}">

              <span style="color: #d65055"
                    v-if="row.upRoi/row.statCostRatio>0">  {{ row.upRoi / row.statCostRatio|dataFilters2 }}</span>

              <span style="color: #5daf34" v-else>  {{ row.upRoi / row.statCostRatio|dataFilters2 }}</span>
            </template>

          </el-table-column>
          <el-table-column property="statCost" label="消耗" sortable width="100" align="center"></el-table-column>
          <el-table-column property="statCostRatio" label="消耗占比" width="150" align="center">

          </el-table-column>
          <el-table-column property="firstHourIncome" label="首小时收入" sortable width="150"
                           align="center"></el-table-column>
          <el-table-column property="incomeRatio" label="收入占比" width="150" align="center">

          </el-table-column>
        </el-table>
      </el-dialog>

    </el-container>

  </div>
</template>

<script>
export default {
  name: "Game4",

  data() {

    return {
      activeTab: 'gameSummary',
      title: "",
      gridData: [],
      dialogTableVisible: false,
      size: 1,
      isSort: true,
      echartShow: false,
      options2: ['+', '-', '*', '/'],
      newProp: '例如(进入游戏)',
      newPropValue: '',
      valProp2: '',
      valueSuan: '',
      colData: [{title: "账面消耗", istrue: true},
        {title: "实际消耗", istrue: false},
      ],
      colOptions: ["账面消耗"], //默认全选
      colSelect: ["账面消耗", "实际消耗"],
      valProp: '例如(1,下一关)',
      titleHeads: [{sta_value: "进入游戏", sta_view_value: "进入游戏"}, {
        sta_value: "下一关",
        sta_view_value: "进入下一关"
      }],
      list: [],
      value1: '',
      currentPage: 1,
      pageSize: 25,
      loading: false,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableData: [],
      summaryRow: null,
      rateColumns: [],
      oldRateColumns: [],
      stdRateColumns: [],
      projectRows: [],
      projectSummary: {},
      projectTotal: 0,
      projectCurrentPage: 1,
      projectPageSize: 50,
      projectSortProp: 'stat_cost',
      projectSortOrder: 'descending',
      projectLoading: false,
      deepBidType: '',
      deepBidTypeOptions: [
        {value: 'ROI_COEFFICIENT', label: 'ROI系数'},
        {value: 'FIRST_ROI_COEFFICIENT', label: '首日ROI系数'},
        {value: 'SEVEN_ROI_COEFFICIENT', label: '7日ROI系数'},
        {value: 'THIRTY_ROI_COEFFICIENT', label: '30日ROI系数'},
        {value: 'DEEP_BID_DEFAULT', label: '默认深度出价'}
      ],
      projectRoiColumns: [
        {prop: 'micro_game_2d_roi', label: '2日ROI'},
        {prop: 'micro_game_3d_roi', label: '3日ROI'},
        {prop: 'micro_game_4d_roi', label: '4日ROI'},
        {prop: 'micro_game_5d_roi', label: '5日ROI'},
        {prop: 'micro_game_6d_roi', label: '6日ROI'},
        {prop: 'micro_game_7d_roi', label: '7日ROI'},
        {prop: 'micro_game_14d_roi', label: '14日ROI'},
        {prop: 'micro_game_30d_roi', label: '30日ROI'}
      ],
      tableData2: [],
      optionsGame: [],
      valueGame: "",
      value: 0,

      ecpmA: 300,
      value2: '',
      value3: 7
      , json_data: []
      , json_fields: {},
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: [],
      person: "",
      maxHeight: 800,
      selectedField: 'statCost',
      selectText: "",
      chartData: [], // 这里放入你的原始数据
      chartInstance: null

    }


  },
  computed: {
    tableHeight() {
      return Math.max(420, this.maxHeight || window.innerHeight - 250)
    },
    displayTableData() {
      return this.summaryRow ? [this.summaryRow].concat(this.tableData || []) : this.tableData
    }
  },
  watch: {

    colOptions(valArr) {
      // alert("sss");
      var arr = this.colSelect.filter(i => valArr.indexOf(i) < 0); // 未选中
      this.colData.filter(i => {
        if (arr.indexOf(i.title) != -1) {
          i.istrue = false;
          this.$nextTick(() => {
            this.$refs.tableDataRef.doLayout();
          });
        } else {
          i.istrue = true;
          this.$nextTick(() => {
            this.$refs.tableDataRef.doLayout();
          });
        }
      });
    }
  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return "-"

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }, dataFilters2(value) {
      // 截取当前数据到小数点后两位
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = (value * 100).toFixed(2) + '%'
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  },
  methods: {
    getGame4Cache() {
      try {
        return JSON.parse(localStorage.getItem("Game4") || "{}") || {}
      } catch (e) {
        return {}
      }
    },
    saveGame4Cache() {
      localStorage.setItem("Game4", JSON.stringify({
        name: this.valueGame,
        date: this.value1,
        pageSize: Number(this.pageSize) || 25,
        projectPageSize: Number(this.projectPageSize) || 50,
        deepBidType: this.deepBidType || '',
        activeTab: this.activeTab
      }))
    },
    restoreGame4Cache() {
      const cache = this.getGame4Cache()
      if (Object.prototype.hasOwnProperty.call(cache, 'name')) {
        this.valueGame = cache.name || ''
      }
      const cachedPageSize = Number(cache.pageSize)
      if ([25, 50, 100, 200].indexOf(cachedPageSize) > -1) {
        this.pageSize = cachedPageSize
      }
      const cachedProjectPageSize = Number(cache.projectPageSize)
      if ([25, 50, 100, 200].indexOf(cachedProjectPageSize) > -1) {
        this.projectPageSize = cachedProjectPageSize
      }
      if (cache.activeTab === 'projectDaily' || cache.activeTab === 'gameSummary') {
        this.activeTab = cache.activeTab
      }
      if (Object.prototype.hasOwnProperty.call(cache, 'deepBidType')) {
        this.deepBidType = cache.deepBidType || ''
      }
    },
    headerCellStyle() {
      return {
        background: '#f7f9fc',
        color: '#1f2d3d',
        fontWeight: 700,
        height: '42px'
      }
    },
    cellClassName({column}) {
      if (!column || !column.property) {
        return ''
      }
      if (column.property === 'gameName') {
        return 'game-name-cell'
      }
      if (column.property === 'statCost') {
        return 'main-cost-cell'
      }
      if (column.property === 'sumRoi' || column.property === 'oldSumRoi' || column.property === 'stdSumRoi') {
        return 'roi-cell'
      }
      if (column.property === 'f1HAmount') {
        return 'speed-cell'
      }
      if (String(column.property).startsWith('rate') && String(column.property).endsWith('Roi')) {
        return 'roi-cell'
      }
      if (column.property === 'oldCost' || column.property === 'stdCost' || String(column.property).startsWith('rate')) {
        return 'cost-cell'
      }
      return ''
    },
    gameRowClassName({row}) {
      return row && row.isSummary ? 'summary-row' : ''
    },
    applyRateColumns(payload) {
      const data = payload || {}
      this.rateColumns = data.rateColumns || []
      this.oldRateColumns = data.oldRateColumns || this.rateColumns.reduce((columns, item) => {
        if (item.oldCostProp || item.statCostProp) {
          columns.push({
            prop: item.oldCostProp || item.statCostProp,
            label: item.oldCostLabel || item.statCostLabel,
            formatter: 'amount'
          })
        }
        if (item.oldRoiProp) {
          columns.push({
            prop: item.oldRoiProp,
            label: item.oldRoiLabel,
            formatter: 'roi'
          })
        }
        return columns
      }, []).filter(item => item.prop)
      this.stdRateColumns = data.stdRateColumns || this.rateColumns.reduce((columns, item) => {
        if (item.stdCostProp || item.sumRoiProp) {
          columns.push({
            prop: item.stdCostProp || item.sumRoiProp,
            label: item.stdCostLabel || item.sumRoiLabel,
            formatter: 'amount'
          })
        }
        if (item.stdRoiProp) {
          columns.push({
            prop: item.stdRoiProp,
            label: item.stdRoiLabel,
            formatter: 'roi'
          })
        }
        return columns
      }, []).filter(item => item.prop)
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.saveGame4Cache()
      this.search(true)
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.search(true)
    },
    handleProjectSizeChange(size) {
      this.projectPageSize = size
      this.projectCurrentPage = 1
      this.saveGame4Cache()
      this.searchProjectDaily()
    },
    handleProjectCurrentChange(page) {
      this.projectCurrentPage = page
      this.searchProjectDaily()
    },
    handleDeepBidTypeChange() {
      this.projectCurrentPage = 1
      this.saveGame4Cache()
      if (this.activeTab === 'projectDaily') {
        this.searchProjectDaily()
      }
    },
    handleTabChange() {
      if (this.activeTab === 'projectDaily') {
        this.projectCurrentPage = 1
      } else {
        this.currentPage = 1
      }
      this.search(true)
    },
    sortMethod(column, prop, order) {

      console.log(column.order)
      console.log(column.prop)
      this.$axios
          .post('/tf2/data/find', {

            gameName: this.valueGame,
            person: this.person == null ? "" : this.person,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            uploadTime: this.value1,
            prop: column.prop,
            order: column.order

          })
          .then(successResponse => {
            const responseData = successResponse.data.data || {}
            this.tableData = responseData.data || []
            this.summaryRow = responseData.summary || null
            this.applyRateColumns(responseData)

            this.tableData.forEach(function (e) {

              e.hasChildren = true
            })

            this.size = responseData.size || 0
            console.log(this.tableData)


            this.loading = false
            this.$nextTick(() => {
              this.$refs.tableData1.doLayout();
            });
          })

    },

    initChart() {
      this.echartShow = true
      this.chartInstance = this.$echarts.init(this.$refs.chart)
      this.updateChart()
    },

    formatAmount(value) {
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue) || Math.abs(numericValue) < 0.000001) {
        return '-'
      }
      return numericValue.toFixed(2)
    },

    formatRoi(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue)) {
        return '-'
      }
      return numericValue.toFixed(3)
    },

    formatDynamicColumn(row, column) {
      if (!row || !column || !column.prop) {
        return '-'
      }
      return column.formatter === 'roi'
          ? this.formatRoi(row[column.prop])
          : this.formatAmount(row[column.prop])
    },

    formatSpeed(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue)) {
        return '-'
      }
      return numericValue.toFixed(1)
    },

    formatInteger(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue)) {
        return '-'
      }
      return Math.round(numericValue).toLocaleString('zh-CN')
    },

    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue)) {
        return '-'
      }
      return numericValue.toFixed(2) + '%'
    },

    formatPlatformVersion(value) {
      const map = {OLD: '旧版', STD: '智擎'}
      return map[value] || value || '-'
    },

    formatDeepBidType(value) {
      const map = {
        ROI_COEFFICIENT: 'ROI系数',
        FIRST_ROI_COEFFICIENT: '首日ROI系数',
        SEVEN_ROI_COEFFICIENT: '7日ROI系数',
        THIRTY_ROI_COEFFICIENT: '30日ROI系数',
        DEEP_BID_DEFAULT: '默认深度出价'
      }
      return map[value] || value || '-'
    },

    formatDateTime(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const text = String(value)
      if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
        return text.replace('T', ' ').replace(/\.\d+/, '').substring(0, 19)
      }
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) {
        return text
      }
      const pad = number => String(number).padStart(2, '0')
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + ' ' +
          pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds())
    },

    sortProjectDaily({prop, order}) {
      this.projectSortProp = prop || 'stat_cost'
      this.projectSortOrder = order || 'descending'
      this.projectCurrentPage = 1
      this.searchProjectDaily()
    },

    searchProjectDaily() {
      if (!this.value1) {
        this.projectRows = []
        this.projectSummary = {}
        this.projectTotal = 0
        return
      }
      this.projectLoading = true
      this.$axios.post('/tf2/data/projectDaily', {
        gameName: this.valueGame,
        currentPage: this.projectCurrentPage,
        pageSize: this.projectPageSize,
        uploadTime: this.value1,
        deepBidType: this.deepBidType,
        prop: this.projectSortProp,
        order: this.projectSortOrder
      }).then(successResponse => {
        const responseData = successResponse.data.data || {}
        this.projectRows = responseData.data || []
        this.projectSummary = responseData.summary || {}
        this.projectTotal = responseData.size || 0
      }).catch(error => {
        this.projectRows = []
        this.projectSummary = {}
        this.projectTotal = 0
        this.$message.error('查询项目天明细失败：' + (error && error.message ? error.message : '未知错误'))
      }).then(() => {
        this.projectLoading = false
        this.$nextTick(() => {
          if (this.$refs.projectDailyTable) {
            this.$refs.projectDailyTable.doLayout()
          }
        })
      })
    },

    updateChart() {
      const xData = this.chartData.map(item =>
          item.uploadTime.split(' ')[1].substring(0, 5) // 提取时间 HH:mm
      )

      const yData = this.chartData.map(item => item[this.selectedField])

      const option = {
        title: {
          text: '数据趋势分析' + this.selectText
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xData.reverse(),
          name: '时间'
        },
        yAxis: {
          type: 'value',
          name: this.selectedLabel
        },
        series: [{
          data: yData.reverse(),
          type: 'line',
          smooth: true,
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {offset: 0, color: 'rgba(58,77,233,0.8)'},
              {offset: 1, color: 'rgba(58,77,233,0.3)'}
            ])
          }
        }]
      }

      this.chartInstance.setOption(option)

      // 窗口变化自适应
      window.addEventListener('resize', () => {
        this.chartInstance.resize()
      })
    },


    contextClick(row, column, cell, event) {
      if (row && row.isSummary) {
        return
      }

      this.selectText = "（游戏名称：" + row.gameName+"）"

      console.log(column)

      if (column.property !== 'promotionId' && column.property !== 'materialId' && column.property !== 'tfPerson' && column.property !== 'statHour'
          && column.property !== 'statCostY'
          && column.property !== 'getPrice'
          && column.property !== 'getType'
          && column.property !== 'ljBl'
          && column.property !== 'sumIncome'
          && column.property !== 'sumRoi'
          && column.property !== 'oldSumRoi'
          && column.property !== 'stdSumRoi'
          && column.property !== 'f1HAmount'
          && !String(column.property || '').startsWith('rate')) {
        this.$axios
            .get('/tf2/data/findByGame?gameName=' + row.gameName, {})
            .then(successResponse => {

              console.log(successResponse.data.data)

              if (column.property !== 'gameName' && column.property !== 'tfPerson') {
                this.selectedField = column.property

                this.selectedLabel = column.label

                this.chartData = successResponse.data.data
                this.initChart()
              }


            })

      }
      console.log(column)


    },
    rowClickEvent(row, column, cell, event) {


      console.log(column)


    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },

    up(e) {

      if (e == 0) {

        if (this.currentPage > 1)
          this.currentPage--
        this.searchPage()

      } else {

        this.currentPage++

        this.searchPage()
      }


    }, clickTo(row) {

      console.log(row)

    },
    searchPage() {
      this.search(true)
    },

    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    }, value_format3(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = value.toFixed(2)

      }
    },
    value_format(row, column, value) {

      console.log(value)
      // 截取当前数据到小数点后两位
      if (value === 0 || isNaN(value) || value * 100 === 0) {

        return "-"
      } else {
        value = (value * 100).toFixed(1) + '%'
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/tf2/data/findSnapshotGameNames', {
            params: {
              uploadTime: this.value1
            }
          })
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },

    search(flag) {

      if (flag) {

        console.log("手动选条件")

        this.saveGame4Cache()

      } else {

        console.log("自动刷")
        this.restoreGame4Cache()
      }

      this.maxHeight = window.innerHeight - 250;
      this.findGame()

      if (this.value1 != '') {

        if (this.activeTab === 'projectDaily') {
          this.searchProjectDaily()
          return
        }

        this.loading = true

        this.$axios
            .post('/tf2/data/find', {

              gameName: this.valueGame,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              uploadTime: this.value1,
              prop: 'statCost',
              order: 'descending'

            })
            .then(successResponse => {
              const responseData = successResponse.data.data || {}
              this.tableData = responseData.data || []
              this.summaryRow = responseData.summary || null
              this.applyRateColumns(responseData)

              this.size = responseData.size || 0
              console.log(this.tableData)


              this.loading = false
              this.$nextTick(() => {
                if (this.$refs.tableData1) {
                  this.$refs.tableData1.doLayout();
                }
              });
            }).catch(error => {
              this.loading = false
              this.$message.error('查询游戏汇总失败：' + (error && error.message ? error.message : '未知错误'))
            })
      }

    },date_day() {
      let date1 = new Date();

      let year = date1.getFullYear();
      let month = date1.getMonth() + 1;
      let day = date1.getDate();

      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      this.value1 = year + "-" + month + "-" + day;
    },

  }
  ,
  updated() {

    this.$nextTick(() => {
      if (this.$refs['tableData1']) {
        this.$refs['tableData1'].doLayout();
      }
      if (this.$refs.projectDailyTable) {
        this.$refs.projectDailyTable.doLayout();
      }
    })

  }
  ,
  mounted: function () {
    this.height = window.innerHeight;
    this.maxHeight = window.innerHeight - 250;
    // this.date_format_new()
    this.restoreGame4Cache()
    this.date_day()

    this.findGame()
    this.search(false)
    for (let i = 0, len = 160; i <= 160; i++) {
      this.items.push(i + '')
    }
  }


}
</script>
<style>


.promotion:hover {
  cursor: pointer;
  color: #303133;
}

.el-table .column-style {
  color: #4d7dd6;
  font-size: 12px;
  font-weight: bold;
}


.el-table .column-style3 {
  color: #d65055;
  font-size: 12px;
  font-weight: 600;
}

.el-table .column-style2 {
  color: #606266;
  font-size: 12px;

  border: 2px dashed #F00;
  border-right: 2px dashed #0F0 !important;
}

.el-progress-bar .el-progress-bar__inner {

  border-radius: inherit;

}

.el-progress-bar .el-progress-bar__outer {
  background-color: rgba(134, 116, 255, 0.54);
  border-radius: inherit;

}


.item {
  margin-top: 8px;
  margin-right: 10px;
  padding: 2px 2px;
}
</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 13px;
  height: 12px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.game-board-page {
  min-height: 96vh;
  background: #f3f6fb;
}

.bbb {
  box-shadow: 0 2px 10px rgba(31, 45, 61, .08);
  padding: 14px 16px 12px;
  border-radius: 6px;
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.game-board-card {
  min-width: 0;
}

.board-tabs {
  margin: -5px 0 2px;
}

.board-tabs .el-tabs__header {
  margin: 0 0 6px;
}

.board-tabs .el-tabs__item {
  height: 34px;
  line-height: 34px;
  font-size: 13px;
}

.contain-6 {
  height: calc(100vh - 40px);
  overflow: hidden;
  padding: 14px 16px;
}

.board-toolbar {
  display: flex;
  align-items: center;
  height: 42px !important;
  padding: 0 !important;
  gap: 8px;
  flex-wrap: nowrap;
}

.style-title {
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.game-select {
  width: 230px;
}

.date-picker {
  width: 145px;
}

.deep-bid-filter {
  width: 145px;
}

.refresh-button {
  height: 28px;
  padding: 7px 13px;
  background-color: #f7f9fc;
  color: #1f2d3d;
  border-color: #d9e2ef;
}

.toolbar-spacer {
  flex: 1;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 9px;
  border: 1px solid #dfe7f2;
  border-radius: 4px;
  background: #f8fbff;
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
}

.game-board-table {
  flex: 1;
  width: 100%;
  margin-top: 10px;
  font-size: 12px;
}

.pagination-bar {
  display: flex;
  align-items: center;
  height: 38px;
  padding-top: 8px;
}
</style>


<style scoped>
::v-deep .el-table .el-table__expanded-cell {
  background: #f8f9fa !important;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05); /* 可选添加内阴影增强效果 */
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}

::v-deep .game-board-table .el-table__header-wrapper th .cell,
::v-deep .game-board-table .el-table__fixed-header-wrapper th .cell {
  white-space: nowrap;
  line-height: 18px;
  font-weight: 700;
}

::v-deep .game-board-table .el-table__body td {
  padding: 5px 0;
}

::v-deep .game-board-table .el-table__body td .cell {
  line-height: 20px;
  white-space: nowrap;
}

::v-deep .game-board-table .el-table__fixed,
::v-deep .game-board-table .el-table__fixed-left {
  box-shadow: 4px 0 8px rgba(31, 45, 61, .08);
}

::v-deep .game-board-table .game-name-cell .cell {
  font-weight: 400;
  color: #303133;
}

::v-deep .game-board-table .main-cost-cell .cell {
  color: #303133;
  font-weight: 400;
}

::v-deep .game-board-table .roi-cell .cell {
  color: #303133;
  font-weight: 400;
}

::v-deep .game-board-table .speed-cell .cell {
  color: #303133;
  font-weight: 400;
}

::v-deep .game-board-table .cost-cell .cell {
  color: #303133;
  font-weight: 400;
  font-variant-numeric: tabular-nums;
}

::v-deep .game-board-table .el-table__row:hover > td {
  background-color: #eef6ff !important;
}

::v-deep .game-board-table .summary-row > td {
  background-color: #f1f6ff !important;
  font-weight: 600;
}

::v-deep .game-board-table .summary-row .promotion {
  color: #303133;
  font-weight: 600;
}

::v-deep .game-board-table .el-table__empty-block {
  min-height: 360px;
}
</style>
